module.exports = __webpack_public_path__ + "static/media/picto_type_designer.023a6787.svg";